/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-06 14:38:31
 * @LastEditTime: 2025-08-14 10:58:13
 */
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { message, Tabs,Spin } from 'antd';
import type { TabsProps } from 'antd';
import CommonHead from '@/components/common-head'
import StickyBox from 'react-sticky-box';
import IntroFeature from './components/introFeature';
import ProductParams, { ProductParamsMethods } from './components/productParams';
import { getDetail } from '@/api/detail';
import useBackToTop from '@/hooks/useBackToTop';
import { resObject, pmsProductObject, detailObject, DetailTabObject } from './type';
import { openCustomerService } from '@/utils';
import Crumb from '@/components/crumb'
import NoData from '@/components/no-data'
import './index.scss';

const ProductDetail: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams(location.search);
  const productSn = searchParams.get('productSn');
  const productParamsRef = useRef<ProductParamsMethods>(null);
  const [detailInfo, setDetailInfo] = useState<any>({});
  const [tabSticky, setTabSticky] = useState(false);
  const [priceInfo, setPriceInfo] = useState<any>({});
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const tabsRef = useRef(null);
  const [manualLink, setManualLink] = useState(''); //用户手册
  const [loading, setLoading] = useState(true);
  const [addCart, setAddCart] = useState(false); // 加入购物车
  const [buyFlag, setBuyFlag] = useState(false); // 立即购买
  useEffect(() => {
    scrollToTop();
  }, [])

  useEffect(() => {
    detailInfoFunc();
  }, [productSn])
  const items: DetailTabObject[] = [
    {
      label: '详情',
      key: '0',
      children: (<IntroFeature tabType={0} detailInfo={detailInfo} />),
    }

  ]
  const detailInfoFunc = () => {
    getDetail({ productId: productSn }).then((pRes: any) => {
      if (pRes.success) {
        setLoading(false);
        setDetailInfo(pRes.obj);
        pRes.obj?.pmsProductAttributeDetails.forEach((pInfo: detailObject) => {
          if (pInfo.type === 7) {
            setManualLink(pInfo.story);
          }
        })
      } else {
        message.warning(pRes.message);
        setLoading(false);
      }
    })
  }
  useEffect(() => {
    const handleScroll = () => {
      const tabContainer: any = tabsRef.current;
      if (tabContainer) {
        const tabsTop = tabContainer?.getBoundingClientRect().top;
        setTabSticky(tabsTop <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const priceChange = (priceInfo: pmsProductObject[], index: number, count: number, maxCount: number) => {
    setPriceInfo({
      models: priceInfo[index].models,
      price: priceInfo[index].price,
      originalPrice: priceInfo[index].originalPrice,
      count: count,
      maxCount: maxCount
    });
  };
   // 获取购买方式
   const getBuyWay = (type:string) => {
    switch (type) { 
      case '0':
        return '永久授权';
      case '1':
        return '日';
      case '2':
        return '周';
      case '3':
        return '月';
      case '4':
        return '季';
      case '5':
        return '年';
      case '10':
        return '次';
      break;
        
    }
  }
  // sdk、api由于接口返回数据格式不一致，不修改原本逻辑，新增的
  const priceSdkChange = (models:string, price: string,unit:string, timeCount: number) => {
    setPriceInfo({
      models: models,
      price: price,
      unit: getBuyWay(unit),
      count: timeCount
    });
  };
console.log(priceInfo,'priceInfo')
  const renderTabBar: TabsProps['renderTabBar'] = (props, DefaultTabBar) => (
    <StickyBox offsetTop={40} offsetBottom={20} style={{ zIndex: 16 }}>
      <div className="custom-tab-bar">
        <DefaultTabBar {...props} />
        {
          manualLink &&
          <div className="user-manual">
            <a href={manualLink} target="_blank" rel="noreferrer">产品手册</a>
          </div>
        }
        <div className={`shopping-cat-content ${tabSticky ? '' : 'hidden'}`}>
          {detailInfo?.product?.productType === 3? (priceInfo.price !== '' && priceInfo.price) ?
              <>
              <div className="price-detail-show">
             
                <div className="price-info">
                
                    <span>￥</span>
                    <span>{priceInfo.price}</span>
                  </div>
                  <p title={priceInfo.models}>{priceInfo.models}({priceInfo.unit})
                    {
                    priceInfo.count > 0 &&priceInfo.unit!=='永久授权'&& <> x{priceInfo.count}</>
                    }
                  </p>
                </div>
                {
                  detailInfo.pmsProductAttributeModels?.length > 0 &&
                  <>
                    <span className="buy-now stick-buy" onClick={()=>setBuyFlag(true)}>立即购买</span>
                  </>
                }
              </> :
              <>
                <div className="price-detail-show">
                  <div className="price-info">
                    <span className="consult-text">{detailInfo?.product?.name}</span>
                  </div>
                  <p>{priceInfo.models}</p>
                </div>
                <span className="consult-now" onClick={(event) => handleService(event)}>立即咨询</span>
              </>:
            (priceInfo.price !== '' && priceInfo.price) ?
              <>
                <div className="price-detail-show">
                  <div className="price-info">
                    <span>￥</span>
                    <span>{priceInfo.price}</span>
                    {
                      priceInfo.originalPrice &&
                      <span className="detail-originalPrice">￥{priceInfo.originalPrice}</span>
                    }
                  </div>
                  <p title={priceInfo.models}>{priceInfo.models}
                    {
                      priceInfo.count > 0 && <> x{priceInfo.count}</>
                    }
                  </p>
                </div>
                {
                  detailInfo.pmsProductAttributeModels?.length > 0 &&
                  <>
                    {
                      priceInfo.maxCount > 0 ?
                        <>
                          <span className="add-cat" onClick={()=>setAddCart(true)}>加入购物车</span>
                          <span className="buy-now" onClick={()=>setBuyFlag(true)}>立即购买</span>
                        </> :
                        <span className="no-count">暂无库存</span>
                    }
                  </>
                }
              </> :
              <>
                <div className="price-detail-show">
                  <div className="price-info">
                    <span className="consult-text">{detailInfo?.product?.name}</span>
                  </div>
                  <p>{priceInfo.models}</p>
                </div>
                <button className='com-btn stick-buy' onClick={(event) => handleService(event)}>在线沟通</button>
                <button className='price-btn' onClick={() => productParamsRef.current?.getPriceFunc()}>立即获取价格</button>
                {/* <span className="consult-now" onClick={(event) => handleService(event)}>立即咨询</span> */}
              </>
          }
        </div>
      </div>
    </StickyBox>
  );

  const handleService = (event: any) => {
    event?.stopPropagation();
    openCustomerService()
  }

  return (
    <div className="product-main">
      <CommonHead type='classify' />
      <div className='product-detail-main'>
        {/* <div className='detail-title'><a href='/home'>首页</a>&gt;<span title={detailInfo?.product?.name}>{detailInfo?.product?.name}</span></div> */}
        <div className='detail-title'><Crumb title={'首页'} subTitle={detailInfo?.product?.name || '全部'} /></div>
          {Object.keys(detailInfo).length >0&&<React.Fragment>
          <ProductParams
            detailInfo={detailInfo}
            priceChange={priceChange}
            priceSdkChange={priceSdkChange}
            productSn={productSn}
            detailInfoFunc={detailInfoFunc}
            addCart={addCart}
            setAddCart={setAddCart}
            buyFlag={buyFlag}
            setBuyFlag={setBuyFlag}
            ref={productParamsRef}
          />
          <i className="line-show"></i>
          <div className="detail-main" ref={tabsRef}>
            <Tabs
              className="detail-content"
              defaultActiveKey="0"
              renderTabBar={renderTabBar}
              items={items}
            >
              {/* <TabPane tab="详情" key="0">
              <IntroFeature tabType={0} detailInfo={detailInfo}/>
            </TabPane> */}
              {/* <TabPane key="1" tab={<a href={manualLink} target="_blank" rel="noreferrer">用户手册</a>}>
            </TabPane> */}
            </Tabs>
          </div>
          </React.Fragment>}
          {!loading&&Object.keys(detailInfo).length ===0&&<NoData title='暂无数据'/>}
      </div>
    </div>
  )
}

export default ProductDetail;